import React, {Component} from 'react';
import YouTube from 'react-youtube';
import FacebookProvider, {Page} from 'react-facebook';
//import Page from '../FbNews.js';

import InstagramEmbed from 'react-instagram-embed';
import ReactDOM from 'react-dom';
import _ from 'lodash';

class Home extends Component {

  constructor(props) {
    super(props);
    this.state = {
      'menu': {
        filter: "grayscale(100%)"
      },
      'play': false,
      'ytHomeStyle': {
        height: "400px"
      },
      'fbNews': [],
      'instaLink': "",
      'fbWidth': 350
    };
    this.onHover = this.onHover.bind(this);
    this.outHover = this.outHover.bind(this);
    this.outHoverYt = this.outHoverYt.bind(this);
    this._onPlay = this._onPlay.bind(this);
    this._onStop = this._onStop.bind(this);
  }


  componentDidMount() {
    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

    if(iOSSafari) {
      this.setState({
        'mobileSafari': {
          "background-attachment": "scroll",
          position: "fixed"
        }
      });
    }

    window.addEventListener('resize', _.throttle(this.handleResize.bind(this), 1000));
    var element = ReactDOM.findDOMNode(this.refs.homeYt);
    var rect = element.getBoundingClientRect();
    this.setState({
      'ytHomeStyle': {
        height: rect.width * 0.5625 + "px"
      },
      'windowInnerHeight': window.innerHeight,
      'windowInnerWidth': window.innerWidth,
      'fbWidth': window.innerWidth > 350 ? 350 : (window.innerWidth - 80)
    });

    fetch('/api/insta/').then(res => res.json()).then(json => {
    /*  setTimeout(() => {
        this.setState({data: JSON.parse(json)});
      }, 2000) */
      this.setState({'instaLink': json});
      //console.log(this.state.instaLink);
      //ReactDOM.findDOMNode(this.refs.hideUntil).style.opacity = 1;
    })

/*
    window.fbAsyncInit = () => {

        window.FB.init({appId: '842265185935454', autoLogAppEvents: true, xfbml: true, version: 'v2.11'});
        this.setState({
          'fbInit': "ok"
        });
        console.log("nnn");

    };

    fetch('/api/fbtkn/').then(res => res.json()).then(json => {
      this.setState({
        'fbToken': json.access_token
      });
      if(this.state.fbToken && this.state.fbInit === "ok") {
        window.FB.api('/PatrikSasOfficial/posts', 'GET', {
          "access_token": this.state.fbToken,
          "limit": "10",
          "date_format": "U"
        }, (response) => {
          response.data.forEach((item, index) => {
            if (item.message) {
              item.date = new Date(item.created_time * 1000);
              var fbNews = this.state.fbNews.slice();
              fbNews.push(item);
              this.setState({fbNews: fbNews});
            }
          });
        });
      }
    });


    (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
*/
  }


  handleResize() {
    var elementYth = ReactDOM.findDOMNode(this.refs.homeYt);
    if(elementYth) {
      var rect = elementYth.getBoundingClientRect();
      this.setState({
        'ytHomeStyle': {
          height: rect.width * 0.5625 + "px"
        },
        'windowInnerHeight': window.innerHeight,
        'windowInnerWidth': window.innerWidth,
        //'fbWidth': window.innerWidth > 350 ? 350 : (window.innerWidth - 80)
      });
    }


  }

  onHover(name) {
    this.setState({
      [name]: {
        filter: "grayscale(0%)"
      }
    });
  }

  outHover(name) {
    this.setState({
      [name]: {
        filter: "grayscale(100%)"
      }
    });
  }

  outHoverYt() {
    if (this.state.play === false) {
      this.setState({
        'ytSasBw': {
          filter: "grayscale(100%)"
        }
      });
    }

  }



  render() {
    /*
    function formatDate(date) {
      var monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];


      var day = date.getDate();
      var monthIndex = date.getMonth();
      var year = date.getFullYear();

      return day + ' ' + monthNames[monthIndex] + ' ' + year;
    }
*/
    const opts = {
      width: '100%',
      height: '100%',
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 0,
        controls: 0,
        showinfo: 0,
        modestbranding: 0
      }
    };

    const InstagramPhoto = () => {
      if(this.state.instaLink !== "") {
        return <InstagramEmbed url={this.state.instaLink} maxWidth={350} className="instaSas" hideCaption={true} containerTagName='div' protocol='' onLoading={() => {}} onSuccess={() => {}} onAfterRender={() => {}} onFailure={() => {}}/>
      }
    }

  /*
  <InstagramEmbed url={this.state.instaLink} maxWidth={350} className="instaSas" hideCaption={true} containerTagName='div' protocol='' onLoading={() => {}} onSuccess={() => {}} onAfterRender={() => {}} onFailure={() => {}}/>

   const News = this.state.fbNews.map((item, index) =>
    <div className="newsItem" key={index}>
      <p>{item.message}</p>
      <span>{formatDate(item.date)}</span>

    </div>); */

    return (<div>

      <section>
        <div className="Wrapper">
          <div className="Content Justify">
            <h2>Welcome to my official website!</h2>

            <p>Hello and welcome,</p>

            <p>I tried to create a website that is easy on the eyes as well as easy to navigate. This is where you can find out about my latests musical projects, activities. As far as I remember myself, music always has been my biggest passion and a lifetime mission. I always try to provide an audience with the show they never forget, making each time unforgettable, speak to their hearts through my playing and present them with emotions and joy.
            </p>
            <p>I would kindly appreciate the support by simply sharing this page with your friends. I’ll try to provide enough useful information over time for every drummer and music lover as well. Including practice tips, advice, videos, photos, articles and much much more.</p>

            <p>Stay tuned.</p>
            <p className="textRight">Best regards,<br/>
              Patrik</p>

          </div>
        </div>
      </section>
      <div className="Line">
        <div className="LineBg1" style={this.state.mobileSafari}></div>
      </div>

      <section ref="homeYt" style={this.state.ytHomeStyle}>
        <div className="ytSas" style={this.state.ytHomeStyle}>
          <YouTube videoId="-MvmyYyWcm4" opts={opts} onReady={this._onReady} onPlay={this._onPlay} onPause={this._onStop} onEnd={this._onStop}/>
      </div>
      </section>
      <div className="Line">
        <div className="LineBg2" style={this.state.mobileSafari}></div>
      </div>
      {/*
      <section>
        <div className="Wrapper">
          <div className="Content">
            <h2>NEWS</h2>
          </div>
        </div>
      </section><div className="Line">
        <div className="LineBg3"></div>
      </div>
*/}


      <section>

        <div className="Wrapper">
          <div className="Content">

            <div className="SocialFeeds">
              {/* <div onMouseOver={() => this.onHover('fbSas')} onMouseLeave={() => this.outHover('fbSas')} style={this.state.fbSas}> */}
              <div>
                <FacebookProvider appId="137654226922205">
                  <Page href="https://www.facebook.com/PatrikSasOfficial" tabs="timeline" className="fbSas" width={this.state.fbWidth} height="416"/>
                </FacebookProvider>
              </div>

              {/* <InstagramEmbed url='https://www.instagram.com/p/Bc5YIBLHkiu/' maxWidth={350} className="instaSas" hideCaption={true} containerTagName='div' protocol='' onLoading={() => {}} onSuccess={() => {}} onAfterRender={() => {}} onFailure={() => {}} onMouseOver={() => this.onHover('instaSas')} onMouseLeave={() => this.outHover('instaSas')} style={this.state.instaSas}/> */}
              {InstagramPhoto()}
            </div>

          </div>
        </div>
      </section>
      <div className="Line">
        <div className="LineBg3" style={this.state.mobileSafari}></div>
      </div>
      <section className="bgLight">

        <div className="Wrapper">
          <div className="Content">
            <h2>THANKS TO</h2>

            <div className="sponsorsLogosWrapper">
              <div className="thanksRoland">
                <a href="https://www.roland.com" target="_blank" rel="noopener noreferrer">
                <img src={require('../img/logo/roland.png')} alt="Roland"/></a>
              </div>
              <div>
                <a href="http://www.tama.com" target="_blank" rel="noopener noreferrer">
                <img src={require('../img/logo/tama.png')} alt="Tama"/></a>
              </div>
              <div>
                <a href="http://www.paiste.com" target="_blank" rel="noopener noreferrer">
                <img src={require('../img/logo/paiste.png')} alt="Paiste"/></a>
              </div>
              <div>
                <a href="http://www.balbex.cz" target="_blank" rel="noopener noreferrer">
                <img src={require('../img/logo/balbex.png')} alt="Balbex"/></a>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>);
  }
  _onReady(event) {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  }

  _onPlay() {
    // access to player in all event handlers via event.target
    this.setState({
      'ytSasBw': {
        filter: "grayscale(0%)"
      },
      'play': true
    });
  }

  _onStop() {
    // access to player in all event handlers via event.target
    this.setState({'play': false});
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.js